<template>
  <div>
    <div class="desktop faq-checker-hero">
      <h1>자주묻는 질문</h1>
    </div>
    <div class="mobile m-faq-checker-hero">
      <h1>Checker</h1>
      <p>자주묻는 질문</p>
    </div>
    <b-container>
      <b-row>
        <b-col sm="11" md="8" offset-md="2">
          <div class="faq-wrapper">
            <div class="faq-question" @click="toggle(1)">
              <span class="desktop">Q. 체커는 모든 창과 문에 설치가 가능한가요?</span>
              <span class="mobile">Q. 체커는 모든 창과 문에
                <br>설치가 가능한가요?
              </span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isFirstDropdownOpen}">
                <img src="@/assets/btn-dropdown-faq.png">
              </span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isFirstDropdownOpen}">
              <p>픽스 포인트와 무빙 포인트만 있으면 가능합니다. 여닫이, 슬라이딩, 상하개폐식 등 다양하게 응용하여 설치가 가능해요.
                <br>단, 부착을 원하는 곳에 체커의 사이즈가 맞아야합니다.
              </p>
              <div class="window-illust-wrapper">
                <div class="window-illust-container">
                  <img src="@/assets/checker/middle-open.png" style="width: 200px;">
                  <div class="illust-text">
                    <img src="@/assets/checker/check.png" alt>
                    <span class="available-window">여닫이</span>
                  </div>
                </div>
                <div class="window-illust-container">
                  <img src="@/assets/checker/left-right.png" style="width: 210px;">
                  <div class="illust-text">
                    <img src="@/assets/checker/check.png" alt>
                    <span class="available-window">슬라이딩</span>
                  </div>
                </div>
                <div class="window-illust-container">
                  <img src="@/assets/checker/up-down.png" style="width: 130px;">
                  <div class="illust-text">
                    <img src="@/assets/checker/check.png" alt>
                    <span class="available-window">상하개폐식</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="faq-question" @click="toggle(2)">
              <span class="desktop">Q. 타 기기와의 차이점은 무엇인가요?</span>
              <span class="mobile">Q. 타 기기와의 차이점은
                <br>무엇인가요?
              </span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isSecondDropdownOpen}">
                <img src="@/assets/btn-dropdown-faq.png">
              </span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isSecondDropdownOpen}">
              <p>체커는 앱에서 실시간 상태 확인이 가능하고
                <br>원하는 시간대를 정해 경계 모드를 켜고 끌 수도 있습니다.
                <br>또한 창문에 설치시 1개의 제품으로 양쪽 창문의 개폐를 감지할 수 있어요.
              </p>
            </div>
            <div class="faq-question" @click="toggle(3)">
              <span class="desktop">Q. 경보음은 얼마나 오래 울리나요?</span>
              <span class="mobile">Q. 경보음은 얼마나
                <br>오래 울리나요?
              </span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isThirdDropdownOpen}">
                <img src="@/assets/btn-dropdown-faq.png">
              </span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isThirdDropdownOpen}">
              <p>문 열림이 감지되면 60초간 울리고, 끄고 싶을 경우 체커의 전원을 꺼주시면 됩니다.</p>
            </div>
            <!-- <div class="faq-question" @click="toggle(4)">
              <span class="desktop">Q. 경보음 기능을 완전히 끌 수 있나요?</span>
              <span class="mobile">Q. 경보음 기능을
                <br>완전히 끌 수 있나요?
              </span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isFourthDropdownOpen}">
                <img src="@/assets/btn-dropdown-faq.png">
              </span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isFourthDropdownOpen}">
              <p>네. 앱에서 경보음을 비활성화 할 수 있습니다. 경보음 기능을 꺼도 열림, 닫힘 상태 확인은 가능합니다.</p>
            </div> -->
            <!-- <div class="faq-question" @click="toggle(5)">
              <span class="desktop">Q. 손님이 와서 잠깐 체커를 끄고 싶은데 어떻게 하나요?</span>
              <span class="mobile">Q. 손님이 와서 잠깐 체커를 끄고
                <br>싶은데 어떻게 하나요?
              </span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isFifthDropdownOpen}">
                <img src="@/assets/btn-dropdown-faq.png">
              </span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isFifthDropdownOpen}">
              <p>체커 본체의 전원을 끄거나, 앱에서 원격으로 경보음 기능을 끌 수 있습니다. 이때는 열림과 닫힘 상태만 확인이 가능합니다.
                <br>미리 원하는 시간대에 경계 모드 활성화, 비활성화 예약도 할 수 있어요.
              </p>
            </div> -->
            <div class="faq-question" @click="toggle(6)">
              <span class="desktop">Q. 반납은 어떻게 진행하나요?</span>
              <span class="mobile">Q. 반납은 어떻게
                <br>진행하나요?
              </span>
              <span class="dropdown-arrow" v-bind:class="{showDropDown: isSixthDropdownOpen}">
                <img src="@/assets/btn-dropdown-faq.png">
              </span>
            </div>
            <div class="faq-answer" v-bind:class="{open: isSixthDropdownOpen}">
              <p>I/O 어플 내, 제품 정보에서 반납 신청을 해주시면 수거를 위해 우체국 기사님께서 연락 후에 방문하십니다. 반납 택배는 무료입니다.</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: 'checker-faq',
  data () {
    return {
      isFirstDropdownOpen: false,
      isSecondDropdownOpen: false,
      isThirdDropdownOpen: false,
      isFourthDropdownOpen: false,
      isFifthDropdownOpen: false,
      isSixthDropdownOpen: false
    }
  },
  methods: {
    toggle: function (division) {
      switch (division) {
        case 1:
          this.isFirstDropdownOpen = !this.isFirstDropdownOpen
          break
        case 2:
          this.isSecondDropdownOpen = !this.isSecondDropdownOpen
          break
        case 3:
          this.isThirdDropdownOpen = !this.isThirdDropdownOpen
          break
        case 4:
          this.isFourthDropdownOpen = !this.isFourthDropdownOpen
          break
        case 5:
          this.isFifthDropdownOpen = !this.isFifthDropdownOpen
          break
        case 6:
          this.isSixthDropdownOpen = !this.isSixthDropdownOpen
          break
      }
    }
  }
}
</script>
<style>
.faq-checker-hero {
  background: url("../../../assets/checker/checker-faq-hero.png") no-repeat center center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}

.faq-checker-hero h1 {
  font-size: 24px;
  font-weight: bold;
  margin-left: 10%;
  color: #3d4953;
}
.m-faq-checker-hero {
  background: url("../../../assets/checker/m-checker-faq-hero.png") no-repeat center center;
  background-size: cover;
  min-height: 442px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}

.m-faq-checker-hero h1 {
  font-size: 18px;
  font-weight: bold;
  color: #3d4953;
}
.m-faq-checker-hero p {
  font-size: 18px;
  margin-top: 25px;
  color: #3d4953;
}

.faq-wrapper {
  margin-top: 60px;
  margin-bottom: 60px;
}
.faq-question {
  font-size: 18px;
  padding: 23px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  cursor: pointer;
}
.faq-answer {
  border-top: solid 1px #dee2e5;
  border-bottom: solid 1px #dee2e5;
  padding: 40px;
  display: none;
}
.faq-answer p {
  font-size: 14px;
  margin: 0;
  line-height: 1.56;
  text-align: left;
}
.open {
  display: block;
  opacity: 1;
}

.dropdown-arrow {
  transition: 0.5s;
}
.dropdown-arrow img {
  width: 18px;
  height: 12px;
}
.showDropDown {
  -webkit-transform: rotate(180deg);
}

.window-illust-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.window-illust-container {
  display: inline-block;
  margin-top: 40px;
  margin-bottom: 40px;
  position: relative;
}

.window-illust-container .illust-text {
  margin-top: 10px;
  color: #6f97fa;
  font-weight: 500;
  position: absolute;
  left: 50%;
  margin-left: -50px;
}

.window-illust-container .illust-text img {
  width: 18px;
}

  @media only screen and (min-device-width : 320px) and (max-device-width : 568px) {
    .faq-question {
      font-size: 16px;
      padding: 20px;
      text-align: left;
      align-items: center;
    }
    .window-illust-wrapper {
      display: block;
      text-align: left;
    }

    .window-illust-container {
      text-align: left;
      margin-bottom: 0px;
    }
    .window-illust-container .illust-text {
      position: relative;
      left: 0;
      margin-left: 0;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/products/checker/CheckerFaq.vue